import React from 'react';
import { Alert, Card, Col, Row, Tag, Typography } from 'antd';
import { CheckCircleOutlined, ClockCircleOutlined } from '@ant-design/icons';
import PageHeader from './PageHeader';

interface ModuleAvailabilityProps {
    title: string;
    description: string;
    available: string[];
    pending: string[];
}

const ModuleAvailability = ({
    title,
    description,
    available,
    pending,
}: ModuleAvailabilityProps) => (
    <div className="v2-page">
        <PageHeader eyebrow="SynRay CRM · V2.0" title={title} description={description} />
        <Alert
            showIcon
            type="info"
            message="页面边界已按设计稿固化"
            description="标记为待接入的功能，其服务端接口尚未完成；当前页面不提供会必然失败的提交入口。"
        />
        <Row gutter={[16, 16]} className="v2-section">
            <Col xs={24} lg={12}>
                <Card
                    title={
                        <>
                            <CheckCircleOutlined className="v2-ok" /> 已可使用
                        </>
                    }
                >
                    {available.length ? (
                        available.map((item) => (
                            <Tag key={item} color="green">
                                {item}
                            </Tag>
                        ))
                    ) : (
                        <Typography.Text type="secondary">暂无</Typography.Text>
                    )}
                </Card>
            </Col>
            <Col xs={24} lg={12}>
                <Card
                    title={
                        <>
                            <ClockCircleOutlined className="v2-warn" /> 服务端待接入
                        </>
                    }
                >
                    {pending.map((item) => (
                        <Tag key={item}>{item}</Tag>
                    ))}
                </Card>
            </Col>
        </Row>
    </div>
);

export default ModuleAvailability;
